export const api_routes_v2 = {
  v2: {
    admin: {
      adminDBMoveDocument: '/v2/admin/adminDBMoveDocument',
      copyAssessmentToUser: '/v2/admin/copyAssessmentToUser',
      duplicateAssessmentInUser: '/v2/admin/duplicateAssessmentInUser',
      getUserInfo: '/v2/admin/getUserInfo',
      getUserInfo2: '/v2/admin/getUserInfo2',
      forceNewTest: '/v2/admin/forceNewTest'
    },
    assessment: {
      initAssessment: '/v2/assessment/initAssessment',
      submitInventory: '/v2/assessment/submitInventory',
      pending: {
        get: {
          getPendingAssessment:
            '/v2/assessment/pending/get/getPendingAssessment'
        }
      },
      get: {
        inventory: '/v2/assessment/get/inventory',
        all: '/v2/assessment/get/all'
      },
      changeAssessmentType: '/v2/assessment/changeAssessmentType',
      enhancedTreatmentRecommendations:
        '/v2/assessment/enhancedTreatmentRecommendations',
      invokeCalculatePatientSubtype:
        '/v2/assessment/invokeCalculatePatientSubtype',
      apiEnqueueCompletedAssessment:
        '/v2/assessment/apiEnqueueCompletedAssessment'
    },
    auth: {
      user: {
        verifyEmail: '/v2/auth/user/verifyEmail',
        sendEmailVerification: '/v2/auth/user/sendEmailVerification',
        postSetPassword: '/v2/auth/user/postSetPassword',
        requestPasswordResetCode: '/v2/auth/user/requestPasswordResetCode',
        register: '/v2/auth/user/register',
        updateProfile: '/v2/auth/user/updateProfile',
        updatePassword: '/v2/auth/user/updatePassword'
      },
      admin: {
        clearPassword: '/v2/auth/admin/clearPassword'
      },
      me: '/v2/auth/me'
    },
    clinic: {
      integration: {
        impact: {
          pilot: {
            join: '/v2/clinic/integration/impact/pilot/join',
            isInPilot: '/v2/clinic/integration/impact/pilot/isInPilot',
            leave: '/v2/clinic/integration/impact/pilot/leave'
          },
          addPatient: '/v2/clinic/integration/impact/addPatient',
          token: {
            isValid: '/v2/clinic/integration/impact/token/isValid',
            decodeToken: '/v2/clinic/integration/impact/token/decodeToken',
            generateSampleToken:
              '/v2/clinic/integration/impact/token/generateSampleToken'
          },
          isAssignedToPatientWithPassportId:
            '/v2/clinic/integration/impact/isAssignedToPatientWithPassportId',
          testIntegration: '/v2/clinic/integration/impact/testIntegration'
        }
      },
      accept: '/v2/clinic/accept',
      invite: {
        clinicadmin: '/v2/clinic/invite/clinicadmin',
        clinician: '/v2/clinic/invite/clinician',
        patient: '/v2/clinic/invite/patient'
      },
      list: {
        clinics: '/v2/clinic/list/clinics',
        patients: '/v2/clinic/list/patients',
        patientsWithAssessmentStatus:
          '/v2/clinic/list/patientsWithAssessmentStatus',
        clinicians: '/v2/clinic/list/clinicians'
      },
      create: '/v2/clinic/create',
      info: {
        editRequestImageUploadURL: '/v2/clinic/info/editRequestImageUploadURL',
        edit: '/v2/clinic/info/edit',
        get: {
          basic: '/v2/clinic/info/get/basic',
          all: '/v2/clinic/info/get/all'
        }
      },
      get: {
        basicInfo: '/v2/clinic/get/basicInfo'
      },
      action: {
        patient: {
          allowAssessments: '/v2/clinic/action/patient/allowAssessments',
          disableAssessments: '/v2/clinic/action/patient/disableAssessments',
          editDetails: '/v2/clinic/action/patient/editDetails'
        },
        clinician: {
          editDetails: '/v2/clinic/action/clinician/editDetails'
        },
        resendInvitation: '/v2/clinic/action/resendInvitation',
        getInvitationLink: '/v2/clinic/action/getInvitationLink'
      },
      query: '/v2/clinic/query',
      payment: {
        processActivateAssessment:
          '/v2/clinic/payment/processActivateAssessment',
        getClinicPaymentConfig: '/v2/clinic/payment/getClinicPaymentConfig'
      },
      onboarding: {
        generateToken: '/v2/clinic/onboarding/generateToken',
        validateToken: '/v2/clinic/onboarding/validateToken',
        registerUser: '/v2/clinic/onboarding/registerUser',
        registerOrganisation: '/v2/clinic/onboarding/registerOrganisation'
      }
    },
    impact: {
      getImpactTestIDFromPassportId: '/v2/impact/getImpactTestIDFromPassportId',
      getImPactTestURL: '/v2/impact/getImPactTestURL',
      impactPassportIdExists: '/v2/impact/impactPassportIdExists',
      receiveImpactScores: '/v2/impact/receiveImpactScores'
    },
    pdfExport: {
      pdfExport: '/v2/pdfExport/pdfExport'
    },
    patient: {
      get: {
        assessments: '/v2/patient/get/assessments',
        assessmentsFull: '/v2/patient/get/assessmentsFull',
        patient: '/v2/patient/get/patient',
        impactProfile: '/v2/patient/get/impactProfile'
      },
      list: {
        patientAssessmentIndex: '/v2/patient/list/patientAssessmentIndex'
      },
      assessmentLink: {
        create: '/v2/patient/assessmentLink/create',
        generateToken: '/v2/patient/assessmentLink/generateToken',
        getAllForPatient: '/v2/patient/assessmentLink/getAllForPatient',
        deactivate: '/v2/patient/assessmentLink/deactivate',
        consumeToken: '/v2/patient/assessmentLink/consumeToken'
      }
    },
    clinician: {
      getClinicianData: '/v2/clinician/getClinicianData',
      get: {
        clinician: '/v2/clinician/get/clinician',
        clinicAdmin: '/v2/clinician/get/clinicAdmin'
      }
    },
    uncategorized: {
      'crx-pubmed-query': '/v2/uncategorized/crx-pubmed-query'
    }
  }
} as const;
